module.exports = __webpack_public_path__ + "roadmap_icon.8fb61dc2fe53c8d1b1fc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/site/roadmap_icon.svg
// module id = 1409
// module chunks = 3